import React from "react";
import {OGC3DTilesDataLoader} from "../loaders/OGC3DTilesDataLoader";
import {ConnectToURLWithQualityPage} from "./ConnectToURLWithQualityPage";

interface Props {
  onPrevious: () => void;
  onReset: () => void;
}

export const ConnectToOGC3DTilesWizard = ({onPrevious, onReset}: Props) => {
  return (
      <ConnectToURLWithQualityPage
          defaultURL="https://sampleservices.luciad.com/ogc/3dtiles/marseille-mesh/tileset.json"
          onCreateLayer={OGC3DTilesDataLoader.createLayer}
          onPrevious={onPrevious}
          onReset={onReset}
      />
  )
}